import { Box, styled } from '@withjoy/joykit';

export const StyledContainer = styled(Box)``;
